<script>
export default {
  name: "LocoBadge",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="loco-badge">
    <div class="loco-badge__label">
      {{ label }}
    </div>

    <div class="loco-badge__icon">
      <slot name="icon" />
    </div>
  </div>
</template>

<style lang="scss">
@import "~bootstrap/scss/mixins/breakpoints";

.loco-badge {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  &__icon {
    margin: 0.5rem 0;

    > * {
      width: 50px;
      height: 50px;
    }
  }

  &__label {
    font-weight: 600;
    text-align: center;
  }

  @include media-breakpoint-up(md) {
    flex-wrap: nowrap;

    &__icon {
      margin: 0;
    }

    &__label {
      flex-grow: 1;
      text-align: right;
      margin-right: 0.5rem;
    }
  }
}
</style>
